type EnvType = 'dev1' | 'test1' | 'test2' | 'pre' | 'prod'

export const getDoaminConfig = (env = '') => {
  const cEnv =
    env || process.env.NODE_ENV || process.env.REACT_APP_NODE_ENV || process.env.VITE_APP_NODE_EVN
  switch (cEnv) {
    case 'prod':
    case 'production':
      return {
        h5: 'https://h5.qiekj.com',
        h5User: 'https://h5user.qiekj.com',
        market: 'https://market.qiekj.com',
        h5Merchant: 'https://h5merchant.qiekj.com',
      }
    case 'pre':
    case 'preview':
      return {
        h5: 'https://pre-h5.qiekj.com',
        h5User: 'https://pre-h5user.qiekj.com',
        market: 'https://pre-market.qiekj.com',
        h5Merchant: 'https://pre-h5merchant.qiekj.com',
      }
    case 'test1':
    case 'test2':
      return {
        h5: `http://${cEnv}-h5.qiekj.com`,
        h5User: `http://${cEnv}-h5user.qiekj.com`,
        market: `http://${cEnv}-market.qiekj.com`,
        h5Merchant: `https://${cEnv}-h5merchant.qiekj.com`,
      }
    case 'dev1':
    case 'development':
    case 'dev':
      return {
        h5: 'http://dev1-h5.qiekj.com',
        h5User: 'http://dev1-h5user.qiekj.com',
        market: 'http://dev1-market.qiekj.com',
        h5Merchant: 'https://dev1-h5merchant.qiekj.com',
      }
    default:
      return {
        h5: 'https://h5.qiekj.com',
        h5User: 'https://h5user.qiekj.com',
        market: 'https://market.qiekj.com',
        h5Merchant: 'https://h5merchant.qiekj.com',
      }
  }
}

export const env = (location.host.includes('-') ? location.host.split('-')[0] : 'prod') as EnvType
export const domains = getDoaminConfig()

// 手机号校验
export const checkMobile = (_: any, value: string) => {
  if (!/^1\d{10}$/.test(value)) {
    return Promise.reject(new Error('请输入11位手机号码'))
  }
  return Promise.resolve()
}

export function replaceUrlParam(
  originalUrl: string,
  paramName: string,
  paramValue: string,
): string {
  const regex = new RegExp(`([?&])${paramName}=.*?(&|$)`, 'i')
  const newUrl = originalUrl.replace(regex, `$1${paramName}=${paramValue}$2`)
  return newUrl
}
